import axios, { AxiosResponse } from "axios";

export interface ToS {
	termsOfServiceId: string;
	fileBlobURI: string;
	productId: string;
}

export const getProducToS = (productId: string) => async (): Promise<AxiosResponse<ToS>> => {
	return await axios.get(`/api/v1/termsofservice/byproduct/${productId}`);
};
